import { useEffect, useState } from "react";
import Button from "../../../../components/Button";
import Wrapper from "../../../../components/Wrapper";
import DataSourceList from "../component/Datasource";
import FileUpload from "../Datasources/fileUpload";
import TextFieldDatasource from "../Datasources/text";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/reduxDispatch";
import { apiTrainBot } from "../../../../services/apiCalls/user/chatbot";
import ChatbotMessaging from "../messaging/chatMessaging";
import ChatBotInfo from "../messaging/chatBotInfo";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { Link } from "react-router-dom";
import WebsiteEmbed from "../EmbedWebsite";
import { ToastContainer } from "react-toastify";

const CreateNewBot = () => {
  const dispatch = useAppDispatch();
  const { userProfile } = useAppSelector((s) => s.userProfile);
  const { singleBotdata } = useAppSelector((s) => s.userBot);

  const [text, setText] = useState("");
  const [status, setStatus] = useState("idle");

  // const sections = ["Data Sources", "Integration", "Settings", "Chatbot"];
  const sections = [
    {
      header: "Data Source",
      subheader: "Train your chatbot with multiple data sources",
      sources: ["Files", "Text", "Website", "Q&A", "Notion"],
    },
    {
      header: "Chatbot",
      subheader: "Try out your chatbot with embedded structure",
      sources: ["Testing", "Infomation"],
    },
    {
      header: "Website Embed",
      subheader: "Embed your chatbot on your website using the iframe below",
      sources: ["Iframe"],
    },
  ];
  const [sectionToggle, setSectionToggle] = useState(false);
  const [selectedSection, setSelectedSection] = useState(sections[0]);

  // const dataSources = ["Files", "Text", "Website", "Q&A", "Notion"];

  const [selectedDataSource, setSelectedDataSource] = useState("Files");

  const processTrainChatBot = () => {
    setStatus("loading");
    dispatch(
      apiTrainBot(
        {
          data: text,
          botId: singleBotdata?.botId,
        },
        setStatus
      )
    );
  };

  useEffect(() => {
    if (status === "success") {
      setStatus("idle");
    }
  }, [status]);

  useEffect(() => {
    selectedSection && setSelectedDataSource(selectedSection?.sources[0]);
  }, [selectedSection]);

  return (
    <div>
      <ToastContainer />
      <Wrapper>
        <div className="container mx-auto px-4 sm:px-8 md:px-20 lg:px-56 py-6 h-[71dvh] flex flex-col">
          <div>
            <div className="flex gap-1">
              <Link
                to="/user/chatbots/"
                className="underline decoration-gray-400 text-gray-400"
              >
                <p>All Chatbots</p>
              </Link>
              <p> / </p>
              <p>{singleBotdata?.botName}</p>
            </div>
            {
              <div className="pb-6 pt-2">
                <div
                  className="relative inline-block text-left py-2"
                  onClick={() => setSectionToggle(!sectionToggle)}
                >
                  <div>
                    <button
                      type="button"
                      className="inline-flex justify-center w-full rounded-md shadow-sm border px-1  py-2 bg-white text-gray-700 hover:bg-gray-50 gap-4 items-center"
                      id="options-menu"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      <h1 className="text-md text-gray-700">
                        {selectedSection?.header}
                      </h1>
                      <div>
                        {sectionToggle ? <FaAngleUp /> : <FaAngleDown />}
                      </div>
                    </button>
                  </div>

                  {/* Dropdown menu */}
                  {sectionToggle && (
                    <div className=" absolute left-0 mt-2 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                      <div
                        className="py-1"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        {sections?.map((section, index) => (
                          <p
                            key={index}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            role="menuitem"
                            onClick={() => {
                              setSectionToggle(false);
                              setSelectedSection(section);
                            }}
                          >
                            {section?.header}
                          </p>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <p className="text-gray-500">{selectedSection?.subheader}</p>
              </div>
            }
            {selectedSection?.sources?.length > 0 && (
              <DataSourceList
                sources={selectedSection.sources}
                setSelectedDataSource={setSelectedDataSource}
                selectedDataSource={selectedDataSource}
              />
            )}
          </div>
          <div className="mt-6 flex-1 gl">
            {/* <div> */}
            {selectedDataSource === "Files" ? (
              <FileUpload />
            ) : selectedDataSource === "Testing" ? (
              <div>
                <ChatbotMessaging />
              </div>
            ) : selectedDataSource === "Infomation" ? (
              <ChatBotInfo />
            ) : selectedDataSource === "Iframe" ? (
              <WebsiteEmbed />
            ) : (
              <TextFieldDatasource text={text} setText={setText} />
            )}
            {selectedSection?.header === "Data Source" && (
              <div className=" md:flex py-10 md:justify-between items-center">
                <p className="text-sm">
                  Total detected characters: {`${text.length}`} / 11,000,000
                  limit
                </p>
                <div className="flex justify-center">
                  <Button
                    loading={status === "loading"}
                    disabled={text === ""}
                    onClick={processTrainChatBot}
                    className="md:w-48 w-full mt-4"
                  >
                    <p className="text-lg">Train Chatbot</p>
                  </Button>
                </div>
              </div>
            )}
            {/* </div> */}
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default CreateNewBot;
